import React, { useMemo } from 'react'
import { BasicFormLayout, Props } from '@carsys/form'
import { Grid } from '@mui/material'
import { DeleteButton } from '@cbgms/components/delete-flow'
import { DELETEResponse } from '@cbgms/api'

export interface IDeleteOptions {
  onDelete: (checkIfDeleteIsPossible: boolean, deleteReason?: string | undefined) => Promise<DELETEResponse>
  onDeleteSuccess: () => Promise<void>
  itemName: string
  deleteScope: string
}
interface IFormLayoutOuterProps extends Props {
  deleteOptions?: IDeleteOptions
}

export const FormikFormLayout: React.FC<IFormLayoutOuterProps> = props => {
  const { deleteOptions, ...rest } = props
  const deleteButton = useMemo(() => {
    return (
      deleteOptions?.onDelete &&
      deleteOptions?.onDeleteSuccess && (
        <Grid item>
          <DeleteButton
            handleDelete={deleteOptions.onDelete}
            handleDeleteSuccess={deleteOptions.onDeleteSuccess}
            deletedItemString={deleteOptions.itemName}
            scope={deleteOptions.deleteScope}
          />
        </Grid>
      )
    )
  }, [deleteOptions])
  return <BasicFormLayout {...rest} deleteButton={deleteButton} />
}

export default FormikFormLayout
